import React, { useState } from 'react';

const APIHubPortal: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const PRICE_ID = "price_1QXdYOURREALID"; // Replace with your real Stripe Price ID

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ priceId: PRICE_ID })
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else throw new Error('No checkout URL');
    } catch (err) {
      console.error(err);
      alert('Payment failed. See console.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>World Tech Marketplace</h1>
      <p>Your gateway to financial APIs and compliance tools.</p>
      <button onClick={handleCheckout} disabled={loading}>
        {loading ? 'Processing...' : 'Purchase Subscription'}
      </button>
    </div>
  );
};

export default APIHubPortal;
